import { render, staticRenderFns } from "./AppTableFooter.vue?vue&type=template&id=931d4d8c"
import script from "./AppTableFooter.vue?vue&type=script&lang=js"
export * from "./AppTableFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports